import { compareCoord, listTiles } from '@tessera/engine';
function rot60(c) {
    return { q: -c.r, r: c.q + c.r };
}
function reflectQ(c) {
    return { q: c.q, r: -c.q - c.r };
}
function compose(f, g) {
    return (c) => f(g(c));
}
const IDENTITY = (c) => c;
export function symmetries() {
    const out = [];
    let rot = IDENTITY;
    for (let i = 0; i < 6; i++) {
        out.push(rot);
        out.push(compose(reflectQ, rot));
        rot = compose(rot60, rot);
    }
    return out;
}
const TRANSFORMS = symmetries();
function stateTag(s) {
    switch (s.kind) {
        case 'normal': return 'N';
        case 'charged': return `C${s.chainDepth}`;
        case 'locked': return `L${s.key}`;
        case 'mixer': return 'M';
        case 'reactive': return 'R';
        case 'fragile': return `F${s.remaining}`;
    }
}
function serialize(board, t) {
    const holes = [];
    for (const [k, st] of board.cells) {
        if (st === 'hole') {
            const [qs, rs] = k.split(',');
            const tc = t({ q: Number(qs), r: Number(rs) });
            holes.push(`${tc.q},${tc.r}`);
        }
    }
    holes.sort();
    const tiles = listTiles(board)
        .map((tile) => {
        const tc = t(tile.coord);
        return { q: tc.q, r: tc.r, color: tile.color, tag: stateTag(tile.state) };
    })
        .sort((a, b) => compareCoord(a, b));
    const tileStr = tiles.map((x) => `${x.q},${x.r}:${x.color}:${x.tag}`).join('|');
    return `R${board.radius};H:${holes.join('|')};T:${tileStr}`;
}
export function canonicalHash(board) {
    let best = null;
    for (const t of TRANSFORMS) {
        const s = serialize(board, t);
        if (best === null || s < best)
            best = s;
    }
    return best;
}
